<template>
  <div class="notificationDetails">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <div class="detailsBanner">
      <ol class="breadNav clearfix ">
        <li class="pull-left"><a href="#">公告通知</a></li>
        <li class="pull-left active">公告详情页</li>
      </ol>
    </div>
    <div class="detailCon">
      <div class="detailsTit">
        <h4>{{noticeInfo.noticeTitle}}</h4>
        <p class="updateTime">更新时间：{{noticeInfo.createTime|time}}</p>
      </div>
      <div class="detailsConBox">
        <p v-html="noticeInfo.noticeContent"></p>
      </div>
      <div class="enclosureCon">
        <span class="enclosureTit" v-if="attachmentFlag == true">附件：</span><p v-for="(attachment,index) in attachementDtos" :key="index"><a :href="attachment.attachmentUrl" >{{attachment.attachmentName}}</a></p>
        <span class="enclosureTit" v-if="attachmentFlag == false">附件：未上传</span>
      </div>
    </div>
  <v-footer  :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
      return {
        hitSearchUrl:'',
        noticeInfo:{},
        navigationColumnInfos:[],
        webConfigInfo:{},
        footerColumnInfos:[],
        noticeId:'',
        attachementDtos:[],
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        attachmentFlag:true
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      let query = this.$route.query;
      this.noticeId = query.noticeId;
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainOneNoticeInfo', {
        noticeId:this.noticeId
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.noticeInfo = this.data.noticeInfo;
        this.attachementDtos = this.data.attachementDtos;
        if(Object.keys(this.attachementDtos).length == 0 || this.attachementDtos.length == 0){
          this.attachmentFlag = false;
        }else{
          this.attachmentFlag == true;
        }
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })

    },
    methods: {
      jump(url){
        window.location.href = url;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/notificationDetails/index.vue